import { AxiosResponse } from "axios";
import { SubGroup, TodayMatch } from "../helpers/interfaces/category";
import { matchResultRequest } from "../helpers/interfaces/match";
import { IMatchData, ITeamData } from "../helpers/interfaces/matchData";
import { ICategoryArticle, ICategoryArticleList, ICategoryDetailsArticles } from "../helpers/interfaces/ranking";
import axios, { apiGet } from "./Api";

const BASE_API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://localhost/';

export const matchesService = {
    getMatch: (id: string) => apiGet<IMatchData, string>("?op=partita&id=" + id),
    getScorers: (matchId: string, team: "A" | "B") => apiGet<IMatchData, string>("?op=marcatoriPerPartita&partita=" + matchId + "&ab=" + team),
    getCategory: (id: string) => apiGet<ICategoryDetailsArticles, string>("?op=categoria&id=" + id),
    getCategoryGroups: (categoryId: number) => apiGet<SubGroup, string>("?op=listaGironi&idCategoria=" + categoryId),
    getMatchesByDay: (date: string) => apiGet<TodayMatch[], string>("?op=partitePerGiorno&giorno=" + date + '&sezione=other'),
    getAllMatches: (date: string) => apiGet<IMatchData[], string>("?op=partitePerGiorno&giorno=" + date),
    getCurrentMatchesByGroup: (groupId: string) => apiGet<IMatchData[], string>("?op=partiteInCorsoPerGirone&id=" + groupId),
    getTeamData: (teamId: string) => apiGet<ITeamData, string>(`?op=societa&id=${teamId}`),
    getTeamNews: (teamId: string) => apiGet<ICategoryArticle[], string>(`?op=listaArticoliSquadra&idSquadra=${teamId}`),
    getArticleData: (idArticle: string) => apiGet<ICategoryArticle, any>('?op=articolo&idArticolo=' + idArticle),
    getCategoryNews: async (
        categoryId: string,
        articles: number,
        page: number = 1
    ) => {
        return await apiGet<ICategoryArticleList, string>(
            `?op=listaArticoliCategoria&idCategoria=${categoryId}&articoli=${articles}&pag=${page}`
        )
    },
    sendResults: async (
        data: matchResultRequest
    ): Promise<{data: number}> => {
        return await axios.post(
            BASE_API_URL + '?op=invioRisultati',
            data
        ).then((response: AxiosResponse<{data: number}>) => {
            return response.data
        }).catch((reason: any) => {
            return Promise.reject(new Error('Sent results error'));
        });
    },
    getTeamMatches: (teamId: string, season: string)=> apiGet<ICategoryArticle, any>('?op=listaPartite&id=' + teamId + "&idStagione=" + season)
};
